import { Injectable } from '@angular/core';

export interface IModuleDraft {
  configModule: Record<string, any>;
  requiresAuth: boolean;
  requiresTriage: boolean;
}

/**
 * Rascunho da configuração dos módulos adicionados na edição de setup e ainda não salvos.
 *
 * Esses módulos só passam a existir no backend depois do PUT do setup, então a tela de
 * configuração (rota filha module/:moduleId) não tem de onde buscar nem onde gravar os valores.
 * O rascunho guarda a configuração até o "Salvar" do setup, que a envia junto com os módulos.
 *
 * É provido no EditSetupComponent, e não em root: a rota filha recebe a mesma instância, e o
 * rascunho é descartado quando o usuário sai da edição sem salvar.
 */
@Injectable()
export class SetupModuleDraftService {
  private readonly drafts = new Map<string, IModuleDraft>();

  add(moduleId: string, draft: IModuleDraft): void {
    this.drafts.set(moduleId, draft);
  }

  get(moduleId: string): IModuleDraft | undefined {
    return this.drafts.get(moduleId);
  }

  has(moduleId: string): boolean {
    return this.drafts.has(moduleId);
  }

  update(moduleId: string, changes: Partial<IModuleDraft>): void {
    const current = this.drafts.get(moduleId);
    if (!current) {
      return;
    }

    this.drafts.set(moduleId, { ...current, ...changes });
  }

  remove(moduleId: string): void {
    this.drafts.delete(moduleId);
  }

  entries(): [string, IModuleDraft][] {
    return Array.from(this.drafts.entries());
  }
}
